const routes = [
    {
        path: "/other/payments/makeup-lessons",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "otherpayment_getmakeuplesson"
        }
    }
];

export default routes;
